import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

// The redirection is done manually on the auth middleware because
// we don't want the staff to be redirected to the client login page
const commonRedirectionConfig = {
  auth: { required: true, redirection: { name: ROUTES.ADMIN_TOOLS.HOME } },
  staff: { required: true },
}

const routes = [
  /**
   * Tools
   */
  {
    name: ROUTES.ADMIN_TOOLS.TOOLS.TASK_ANALYZER,
    path: 'tools/task_analyzer',
    component: () =>
      dynamicImport(import('@admin-tools/modules/tools/pages/task-analyzer')),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.TOOLS.FIELD_VALIDATION_PLAYGROUND,
    path: 'tools/field_validation_playground',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/tools/pages/FieldValidationPlayground'),
      ),
    meta: commonRedirectionConfig,
  },
  /**
   * Catalog
   */
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.TOOLS.BULK_ACTIONS,
    path: 'catalog/tools/bulk_actions',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/catalog/pages/tools/bulk-actions'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.PRODUCTS.LIST,
    path: 'catalog/products',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/catalog/pages/products/search'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    path: 'catalog/products/:akeneoProductId',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/catalog/pages/products/single'),
      ),
    meta: commonRedirectionConfig,
    redirect: { name: ROUTES.ADMIN_TOOLS.CATALOG.PRODUCTS.ITEM.AKENEO },
    children: [
      {
        name: ROUTES.ADMIN_TOOLS.CATALOG.PRODUCTS.ITEM.AKENEO,
        path: 'details',
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/catalog/pages/products/single/children/ProductDetails'
            ),
          ),
      },
      {
        path: 'buyback/backboxes',
        name: ROUTES.ADMIN_TOOLS.CATALOG.PRODUCTS.ITEM.BUYBACK.BACKBOXES,
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/catalog/pages/products/single/children/Backboxes'
            ),
          ),
      },
      {
        path: 'buyback/listings',
        name: ROUTES.ADMIN_TOOLS.CATALOG.PRODUCTS.ITEM.BUYBACK.LISTINGS,
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/catalog/pages/products/single/children/Listings'
            ),
          ),
      },
    ],
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.TOOLS.AKENEO.IMAGES.UPLOAD,
    path: 'catalog/tools/akeneo/images/upload',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/catalog/pages/tools/akeneo/images/upload'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.BUYBACK.CATEGORIES.LIST,
    path: 'catalog/buyback/categories',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/catalog/pages/buyback/categories'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.BUYBACK.MERCHANT.PRODUCT.LISTINGS,
    path: 'catalog/buyback/merchants/:merchantId/products/:productId',
    component: () =>
      dynamicImport(
        import(
          '@admin-tools/modules/catalog/pages/buyback/merchant/product/listings'
        ),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.BUYBACK.LISTINGS.SEARCH,
    path: 'catalog/buyback/listings/search',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/catalog/pages/buyback/search'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.VALIDATION.PRODUCTS.HISTORY,
    path: 'catalog/validations/products/history',
    component: () =>
      dynamicImport(
        import(
          '@admin-tools/modules/catalog/pages/validations/products/history'
        ),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.VALIDATION.PRODUCTS.LIST,
    path: 'catalog/validations/products',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/catalog/pages/validations/products/list'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.VALIDATION.PRODUCTS.REMATCH.ITEM,
    path: 'catalog/validations/rematch/products/:productId',
    component: () =>
      dynamicImport(
        import(
          '@admin-tools/modules/catalog/pages/validations/products/rematch/search'
        ),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.VALIDATION.LISTINGS.REMATCH,
    path: 'catalog/validations/rematch/listings/:productId/:productIdToCompare',
    component: () =>
      dynamicImport(
        import(
          '@admin-tools/modules/catalog/pages/validations/listings/rematch'
        ),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.SALES.CATEGORIES.RESTRICTED.LIST,
    path: 'catalog/sales/categories/restricted',
    component: () =>
      dynamicImport(
        import(
          '@admin-tools/modules/catalog/pages/sales/categories/restricted'
        ),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.SALES.LISTINGS.LIST,
    path: 'catalog/sales/listings',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/catalog/pages/sales/listings/search'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    path: 'catalog/sales/listings/:listingId/lifecycle',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/catalog/pages/sales/listings/lifecycle'),
      ),
    meta: commonRedirectionConfig,
    redirect: {
      name: ROUTES.ADMIN_TOOLS.CATALOG.SALES.LISTINGS.LIFECYCLE.INDEX,
    },
    children: [
      {
        path: 'marketized-attributes',
        name: ROUTES.ADMIN_TOOLS.CATALOG.SALES.LISTINGS.LIFECYCLE.INDEX,
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/catalog/pages/sales/listings/lifecycle/children/MarketizedAttributes'
            ),
          ),
      },
      {
        path: 'online-conditions',
        name: ROUTES.ADMIN_TOOLS.CATALOG.SALES.LISTINGS.LIFECYCLE
          .ONLINE_CONDITIONS,
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/catalog/pages/sales/listings/lifecycle/children/OnlineConditions'
            ),
          ),
      },
      {
        path: 'history',
        name: ROUTES.ADMIN_TOOLS.CATALOG.SALES.LISTINGS.LIFECYCLE.HISTORY,
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/catalog/pages/sales/listings/lifecycle/children/History'
            ),
          ),
      },
    ],
  },
  {
    name: ROUTES.ADMIN_TOOLS.CATALOG.SALES.PRODUCTS.UPDATE,
    path: 'catalog/sales/product/update/:productId',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/catalog/pages/sales/product/update'),
      ),
    meta: commonRedirectionConfig,
  },
  /**
   * Customers
   */
  {
    name: ROUTES.ADMIN_TOOLS.CUSTOMERS.INDEX,
    path: 'customers',
    component: () => dynamicImport(import('@admin-tools/modules/customers')),
    meta: {
      auth: { required: true, redirection: { name: ROUTES.ADMIN_TOOLS.HOME } },
      staffOrCareBpo: { required: true },
    },
  },

  /** Sales Limitations */
  {
    name: ROUTES.ADMIN_TOOLS.SALES.LIMITATIONS,
    path: 'sales-limitations',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/sales/pages/sales-limitations'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.SALES.RATINGS_REVIEWS,
    path: 'ratings-reviews',
    component: () =>
      dynamicImport(import('@admin-tools/modules/sales/pages/ratings-reviews')),
    meta: commonRedirectionConfig,
  },
  /** Sellers */
  {
    path: 'sellers/:sellerId',
    component: () =>
      dynamicImport(import('@admin-tools/modules/sellers/pages/single')),
    meta: commonRedirectionConfig,
    redirect: {
      name: ROUTES.ADMIN_TOOLS.CATALOG.SELLERS.ITEM.BUYBACK_LISTINGS,
    },
    children: [
      {
        name: ROUTES.ADMIN_TOOLS.CATALOG.SELLERS.ITEM.BUYBACK_LISTINGS,
        path: 'buyback-listings',
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/sellers/pages/single/children/BuybackListings'
            ),
          ),
      },
      {
        name: ROUTES.ADMIN_TOOLS.CATALOG.SELLERS.ITEM.RATE_LIMITING,
        path: 'rate-limiting',
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/sellers/pages/single/children/RateLimiting'
            ),
          ),
      },
    ],
  },

  /**
   * Repair
   */
  {
    path: '/bo_admin/repair/seller/:sellerId',
    name: ROUTES.ADMIN_TOOLS.REPAIR.SELLER,
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/repair/pages/sellerAdmin/sellerAdmin.vue'),
      ),
    meta: commonRedirectionConfig,
  },

  /**
   * Insurances
   */
  {
    name: ROUTES.ADMIN_TOOLS.INSURANCES.CANCEL,
    path: 'insurances/:policyId/cancel',
    component: () =>
      dynamicImport(
        import(
          '@admin-tools/modules/insurances/pages/PolicyCancellationPage.vue'
        ),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.INSURANCES.STATUS,
    path: 'insurances/:policyId/status',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/insurances/pages/PolicyStatusPage.vue'),
      ),
    meta: commonRedirectionConfig,
  },
  /**
   * Landing Pages Management
   */
  {
    name: ROUTES.ADMIN_TOOLS.LANDING_PAGES.BULK_IMPORTS,
    path: 'landing-pages/bulk-imports',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/landing-pages/pages/bulk-imports'),
      ),
    meta: commonRedirectionConfig,
  },
  /**
   * Finance
   */
  {
    name: ROUTES.ADMIN_TOOLS.FINANCE.PICSOU,
    path: 'finance/picsou',
    component: () =>
      dynamicImport(import('@admin-tools/modules/finance/pages/picsou')),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.FINANCE.REASONS_OLD,
    path: 'finance/reasons',
    component: () =>
      dynamicImport(import('@admin-tools/modules/finance/pages/reasonsOld')),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.FINANCE.REASONS,
    path: 'finance/reasons-new',
    component: () =>
      dynamicImport(import('@admin-tools/modules/finance/pages/reasons')),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.FINANCE.SELLER_COMPENSATIONS,
    path: 'finance/seller-compensations',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/finance/pages/sellerCompensations'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.FINANCE.CREDIT_REQUESTS,
    path: 'finance/credit-requests',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/finance/pages/creditRequests'),
      ),
    meta: commonRedirectionConfig,
  },
  // TODO: The following is a redirect from '/bo_admin/credit-requests' to '/bo_admin/finance/credit-requests'.
  //       It should be deleted at some point.
  {
    name: ROUTES.ADMIN_TOOLS.FINANCE.CREDIT_REQUESTS_REDIRECT,
    path: 'credit-requests',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/finance/pages/creditRequests'),
      ),
    meta: commonRedirectionConfig,
    redirect: {
      name: ROUTES.ADMIN_TOOLS.FINANCE.CREDIT_REQUESTS,
    },
  },
  {
    name: ROUTES.ADMIN_TOOLS.FINANCE.CCBM_FEE_RULES,
    path: 'finance/ccbm-fee-rules',
    component: () =>
      dynamicImport(import('@admin-tools/modules/finance/pages/ccbmFeeRules')),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.FINANCE.TAX_COLLECTION,
    path: 'finance/tax-collection',
    component: () =>
      dynamicImport(import('@admin-tools/modules/finance/pages/taxCollection')),
    meta: commonRedirectionConfig,
  },
  /**
   * Orders
   */
  {
    name: ROUTES.ADMIN_TOOLS.ORDERS.MANUAL_REFUNDS,
    path: 'orders/manual-refunds',
    component: () =>
      dynamicImport(import('@admin-tools/modules/orders/pages/manualRefunds')),
    meta: commonRedirectionConfig,
  },
  /**
   * Backship
   */
  {
    name: ROUTES.ADMIN_TOOLS.BACKSHIP.TRADELINES,
    path: 'backship/billing/tradelines',
    component: () =>
      dynamicImport(import('@admin-tools/modules/backship/pages/tradelines')),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.BACKSHIP.BILLING.INVOICES,
    path: 'backship/billing/invoices',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/backship/pages/billing/invoices'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    name: ROUTES.ADMIN_TOOLS.BACKSHIP.BILLING.SELLER_CHARGES,
    path: 'backship/billing/seller-charges/:carrierCodename',
    component: () =>
      dynamicImport(
        import('@admin-tools/modules/backship/pages/billing/sellerCharges'),
      ),
    meta: commonRedirectionConfig,
  },
  {
    path: 'backship/billing/margins-configuration',
    component: () =>
      dynamicImport(
        import(
          '@admin-tools/modules/backship/pages/billing/sellerChargesMargins'
        ),
      ),
    meta: commonRedirectionConfig,
    redirect: {
      name: ROUTES.ADMIN_TOOLS.BACKSHIP.BILLING.SELLER_CHARGES_MARGINS
        .CARRIER_BACKSHIP_MARGINS,
    },
    children: [
      {
        path: 'carrier-backship-margins',
        name: ROUTES.ADMIN_TOOLS.BACKSHIP.BILLING.SELLER_CHARGES_MARGINS
          .CARRIER_BACKSHIP_MARGINS,
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/backship/pages/billing/sellerChargesMargins/CarrierBackshipMargins'
            ),
          ),
      },
      {
        path: 'tradeline-backship-margins',
        name: ROUTES.ADMIN_TOOLS.BACKSHIP.BILLING.SELLER_CHARGES_MARGINS
          .TRADELINE_BACKSHIP_MARGINS,
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/backship/pages/billing/sellerChargesMargins/TradelineBackshipMargins'
            ),
          ),
      },
      {
        path: 'seller-backship-margins',
        name: ROUTES.ADMIN_TOOLS.BACKSHIP.BILLING.SELLER_CHARGES_MARGINS
          .SELLER_BACKSHIP_MARGINS,
        component: () =>
          dynamicImport(
            import(
              '@admin-tools/modules/backship/pages/billing/sellerChargesMargins/SellerBackshipMargins'
            ),
          ),
      },
    ],
  },
]

export default () => {
  return [
    {
      path: '/bo_admin',
      component: () =>
        dynamicImport(import('./shared/components/layouts/Base.vue')),
      children: routes,
    },
    /**
     * Legacy routes
     */
    {
      name: ROUTES.ADMIN_TOOLS.HOME,
      path: '/bo_merchant/admin_tools/dashboard',
      meta: { disableClientSideNavigation: true },
    },
    {
      name: ROUTES.ADMIN_TOOLS.CATALOG.SALES.PRODUCTS.LIST,
      path: '/bo_merchant/admin_tools/choose_product_to_duplicate',
      meta: { disableClientSideNavigation: true },
    },
    {
      name: ROUTES.ADMIN_TOOLS.CATALOG.VALIDATION.PRODUCTS.REMATCH.LIST,
      path: '/bo_merchant/admin_tools/validate_products',
      meta: { disableClientSideNavigation: true },
    },
    {
      name: ROUTES.ADMIN_TOOLS.SALES.ORDERS,
      path: '/bo_merchant/admin_tools/orders',
      meta: { disableClientSideNavigation: true },
    },
    {
      name: ROUTES.ADMIN_TOOLS.CUSTOMERS.ACCOUNT,
      path: '/bo_merchant/admin_tools/clients',
      meta: { disableClientSideNavigation: true },
    },
    {
      name: ROUTES.ADMIN_TOOLS.SALES.REFUNDS,
      path: '/bo_merchant/admin_tools/refunds',
      meta: { disableClientSideNavigation: true },
    },
    {
      name: ROUTES.ADMIN_TOOLS.CUSTOMERS.PERSONAL_DATA,
      path: '/bm/bo-admin/customer/:customerId/personal-data',
      meta: { disableClientSideNavigation: true },
    },
    {
      name: ROUTES.ADMIN_TOOLS.SOURCING.ORDERS,
      path: '/bo_merchant/admin_tools/sourcing/orders/:orderId',
      meta: { disableClientSideNavigation: true },
    },
    {
      name: ROUTES.ADMIN_TOOLS.SOURCING.ORDERS_LIST,
      path: '/bo_merchant/admin_tools/sourcing/orders/',
      meta: { disableClientSideNavigation: true },
    },
    {
      name: ROUTES.ADMIN_TOOLS.SALES.PROMOTION_CODES,
      path: '/bo_merchant/admin_tools/promotions_codes/',
      meta: { disableClientSideNavigation: true },
    },
  ]
}
